import React from 'react';
import CovidEndpage from './CovidEndpage';
import RebrandExistingUser from './RebrandExistingUser';
import RebrandEpForm from './RebrandEpForm';
import StandardEndpage from './StandardEndpage';
import EmbeddedNonBranded from './EmbeddedNonBranded';
import Embedded from './Embedded';
import Research from './Research';
import NonBranded from './NonBranded';
import RebrandEpFormIntl from './RebrandEpFormIntl';
import { EndpageVariant } from '~helpers/pages/types';
import PollingEndpage from './StandardEndpage/PollingEndpage';

export type WeightedElement = {
  page: EndpageVariant;
  weight: number;
  surveyId?: string;
};

export type PollingRegionEndpagesList = {
  region: string;
  templates: WeightedElement[];
};

export type PollingCountryEndpageList = {
  country: string;
  regions: PollingRegionEndpagesList[];
  templates: WeightedElement[];
};

// The POLLING_ENDPAGES constant is a temporary variable used to manage polling endpages.
// See this confluence page for more context: https://surveymonkey.atlassian.net/wiki/spaces/EO/pages/1161724514/Webplatform+Polling+Endpages+V1
export const POLLING_COUNTRY_ENDPAGES: PollingCountryEndpageList[] = [
  {
    country: 'US',
    regions: [],
    templates: [
      {
        /* continuous national polling */
        page: 'pollingUsMap',
        weight: 0.1,
        surveyId: 'OUVAXS34BA',
      },
    ],
  },
];

export const GUAC_EXISTING_USER_PAGES: WeightedElement[] = [{ page: 'rebrandExistingUser', weight: 1.0 }];

export const NON_GUAC_EXISTING_USER_PAGES: WeightedElement[] = [{ page: 'rebrandExistingUser', weight: 1.0 }];

export const US_GEO_PAGES: WeightedElement[] = [
  { page: 'covidEndpage', weight: 0.3 },
  { page: 'rebrandEpForm', weight: 0.7 },
];

export const GAC_GEO_PAGES: WeightedElement[] = [{ page: 'rebrandEpForm', weight: 1.0 }];

export const NON_GUAC_GEO_PAGES: WeightedElement[] = [{ page: 'rebrandEpForm', weight: 1.0 }];

export const NON_ENGLISH_PAGES: WeightedElement[] = [{ page: 'rebrandEpFormIntl', weight: 1.0 }];

export const endpageVariants: { [key: string]: React.ReactElement } = {
  pollingUsMap: <PollingEndpage pageName="PollingUSMap" utSource="survey-thanks" />,
  covidNearYouEndpage: <PollingEndpage pageName="CovidNearYouEndpage" utSource="survey-thanks" />,
  pollingCanadaMap: <PollingEndpage pageName="PollingCanadaMap" utSource="survey-thanks" />,
  cxEndpage: <StandardEndpage pageName="CxEndpage" utSource="survey-thanks" />,
  racialJusticeEndpage: <StandardEndpage pageName="RacialJusticeEndpage" utSource="survey-thanks" />,
  corporateSignatureResearchEndpage: (
    <StandardEndpage pageName="CorporateSignatureResearchEndpage" utSource="survey-thanks" />
  ),
  mrxEndpage: <StandardEndpage pageName="MrxEndpage" utSource="survey-thanks" />,
  giancarloEndpage: <StandardEndpage pageName="GiancarloEndpage" utSource="survey-thanks" />,
  rebrandEpForm: <RebrandEpForm />,
  rebrandEpFormV1: <RebrandEpForm experiment />,
  covidEndpage: <CovidEndpage />,
  rebrandExistingUser: <RebrandExistingUser />,
  embeddedNonBranded: <EmbeddedNonBranded />,
  embedded: <Embedded />,
  research: <Research />,
  nonBranded: <NonBranded />,
  rebrandEpFormIntl: <RebrandEpFormIntl />,
};
